import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const coreValues = [
  {
    icon: 'ri-shield-check-line',
    title: '신뢰 / Trust',
    desc: '모든 파트너십과 납품에서 투명하고 일관된 품질을 약속합니다.',
  },
  {
    icon: 'ri-tools-line',
    title: '전문성 / Expertise',
    desc: '다양한 산업 분야에서 축적한 기술적 깊이와 현장경험이 우리의 강점입니다.',
  },
  {
    icon: 'ri-global-line',
    title: '글로벌 / Global',
    desc: '검증된 글로벌 네트워크를 통해 고객의 해외 비즈니스를 현실로 만듭니다.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '혁신 / Innovation',
    desc: '기술의 경계를 넓혀 고객에게 더 나은 솔루션을 지속적으로 제공합니다.',
  },
];

export default function About() {
  const leftAnim = useScrollAnimation();
  const rightAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="about" className="py-16 sm:py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          {/* Left: Text */}
          <div
            ref={leftAnim.ref}
            className={`transition-all duration-700 ${leftAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-8 h-[2px] bg-[#E8650A]"></span>
              <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Company Overview</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A2530] mb-8 leading-tight">
              우리는 단순 공급사가 아닌{' '}
              <span className="text-[#E8650A] whitespace-nowrap">진정한 파트너</span>입니다
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6 text-[15px]">
              Fixcope는 첨단 기술과 글로벌 파트너십을 기반으로 산업용 비전 인스펙션, 의료장비 및 제품의 해외공급, 초소형 특수카메라 개발, 국제비즈니스 컨설팅을 아우르는 종합 기술 솔루션 기업입니다.
            </p>
            <p className="text-gray-600 leading-relaxed text-[15px]">
              풍부한 산업 현장 경험과 검증된 글로벌 파트너십을 바탕으로, 고객이 직면한 복잡한 기술·비즈니스 과제를 신속하고 신뢰할 수 있는 방식으로 해결합니다. Fixcope는 단순한 제품 공급을 넘어, 고객의 성장을 함께 만들어가는 진정한 파트너가 되겠습니다.
            </p>
            <div className="mt-10 flex items-center gap-4">
              <button
                onClick={() => {
                  const el = document.querySelector('#contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 bg-[#E8650A] text-white rounded-lg text-sm font-semibold hover:bg-[#C95508] transition-all whitespace-nowrap cursor-pointer"
              >
                협력 문의하기
              </button>
              <button
                onClick={() => {
                  const el = document.querySelector('#business');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg text-sm font-semibold hover:border-[#E8650A] hover:text-[#E8650A] transition-all whitespace-nowrap cursor-pointer"
              >
                사업 분야 보기
              </button>
            </div>
          </div>

          {/* Right: Core Values */}
          <div
            ref={rightAnim.ref}
            className={`grid grid-cols-1 sm:grid-cols-2 gap-5 transition-all duration-700 ${rightAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            {coreValues.map((v, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-[#FEF3E8] border border-[#FDE8CC] hover:border-[#E8650A]/30 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#E8650A]/10 mb-4">
                  <i className={`${v.icon} text-xl text-[#E8650A]`}></i>
                </div>
                <h4 className="text-sm font-bold text-[#1A2530] mb-2 whitespace-nowrap">{v.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
